export { default } from 'app/developer-v3/pages/authentication/AuthenticationSchemePicker/AuthenticationSchemePicker';
